<template>
  <div class="my-broker">
    <van-dropdown-menu>
      <van-dropdown-item v-model="value1" :options="option1" @change='onChange' />
    </van-dropdown-menu>
    <div :class="infoData.gender=='男'?'broker man-broker':'broker'">
      <div class="broker-info">
        <div class="info-name">{{infoData.realName}}</div>
        <div>{{infoData.profiles}}</div>
        <div class="info-img">
          <img :src="infoData.bodyImg" alt />
        </div>
      </div>
      <div class="info-but">
        <!-- <van-button round color="#666666">拨打电话</van-button> -->
        <div class="but-0">
          <a :href="'tel:'+infoData.phone">拨打电话</a>
        </div>
        <!-- <van-button round color="#FC6E09">发起聊天</van-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import URLTC from "@/api/apiTC";
export default {
  data() {
    return {
      value1: '',
      option1: [
        { text: '请选择', value: 0 },
        { text: '张三', value: 1 },
        { text: '李四', value: 2 },
      ],
      infoData:{}
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    getData(){
      let that=this
      let data={
        userId:localStorage.getItem('userid'),
      }
      that.$fetchGet(URLTC.getStaffs.url ,data).then(res=>{
        if(res.data.code==20000){
          that.option1=res.data.data
          // this.option1.unshift({realName:'请选择',id:0})
          that.option1.map(x=>{
            x.text=x.realName
            x.value=x.id
          })
          that.value1=that.option1[0].value
          that.onChange()
        }
      })
    },
    onChange(){
      let that=this
      that.$fetchGet(URLTC.getStaffsInfo.url ,{userId:that.value1}).then(res=>{
        if(res.data.code==20000){
          that.infoData=res.data.data
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.my-broker {
  width: 355px;
  margin: auto;
  font-family: PingFang SC;
  font-weight: 500;
  /deep/ .van-dropdown-item {
    width: 95%;
    margin: auto;
  }
  /deep/ .van-dropdown-menu__title {
    width: 90%;
    padding: 0;
  }
  /deep/ .van-overlay {
    background: transparent;
  }
  .broker {
    height: 586px;
    background: url("../imgs/f-bg.png") no-repeat 100%;
    background-size: 100% 100%;
    overflow: hidden;
    position: relative;
    .broker-info {
      width: 123px;
      margin: 288px 0 0 30px;
      font-size: 9px;
      color: #375069;
      .info-name {
        margin-bottom: 10px;
        font-size: 19px;
        font-weight: bold;
        color: #2a4872;
      }
      .info-img {
        width: 147px;
        position: absolute;
        top: 60px;
        right: 10px;
        img {
          width: 100%;
        }
      }
    }
    .info-but {
      position: absolute;
      bottom: 20px;
      right: 35px;
      .but-0{
        width: 110px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: rgb(102, 102, 102);
        border-radius: 20px;
        font-size: 14px;
        a{
          color: #fff;
        }
      }
    }
  }
  .man-broker {
    background: url("../imgs/man-bg.png") no-repeat 100%;
    background-size: 100% 100%;
  }
}
</style>